import {noop} from "./globalUtils";
const isDebug = (): boolean => typeof(window)!== "undefined" && typeof ((window as any).DEBUG) !== "undefined" && (window as any).DEBUG === true;
export const logIfDebug = (message:string) => isDebug() ? console.log(message) : noop();
export const warnIfDebug = text => isDebug() ? console.warn(text) : noop();
export const alertIfDebug = (text:string) => isDebug() ? alert(text) : noop();
